export default __webpack_public_path__ + "static/media/trail.f4ffa1e8.png";